<template>
  <portal-layout>
    <div class="order-page">
      <div class="page-head">
        <h2 class="page-title">我的订单</h2>
      </div>

      <!-- 状态筛选 -->
      <div class="filter-card">
        <span v-for="tab in tabs" :key="tab.value" class="filter-option"
              :class="{ active: currentStatus === tab.value }"
              @click="changeStatus(tab.value)">{{ tab.label }}</span>
      </div>

      <div v-loading="loading" class="order-list">
        <div v-if="!loading && orders.length === 0" class="empty-tip">
          暂无订单数据
          <el-button type="text" @click="goShop">去逛逛</el-button>
        </div>

        <div v-for="order in orders" :key="order.orderNo" class="order-card">
          <!-- 订单头部 -->
          <div class="order-header">
            <span class="order-no">订单号：{{ order.orderNo }}</span>
            <span class="order-status" :style="{ color: statusColor(order.status) }">
              {{ statusText(order.status) }}
            </span>
          </div>

          <!-- 订单商品 -->
          <div class="order-body" @click="goDetail(order)">
            <div v-for="item in order.orderItems" :key="item.commodityCode" class="order-item">
              <div class="item-cover">
                <img :src="item.mainPic" :alt="item.title" />
              </div>
              <div class="item-info">
                <div class="item-title">{{ item.title }}</div>
                <div class="item-subtitle">{{ item.subtitle }}</div>
                <div class="item-meta">
                  <el-tag size="mini" :type="item.teachingFormat === 'live' ? 'danger' : ''" effect="plain">
                    {{ item.teachingFormat === 'live' ? '直播' : '录播' }}
                  </el-tag>
                  <span v-if="item.courseName" class="meta-text">
                    {{ item.courseName }} × {{ item.courseNum }}次
                  </span>
                </div>
                <div class="item-price">¥{{ item.price }} × {{ item.quantity }}</div>
              </div>
            </div>
          </div>

          <!-- 订单底部 -->
          <div class="order-footer">
            <span class="total-amount">实付：<em>¥{{ order.totalAmount }}</em></span>
            <div class="btn-group">
              <span v-if="order.payTime && (order.status === '2' || order.status === '3')"
                    class="pay-time">{{ order.payTime }}</span>
              <el-button v-if="order.status === '1'" size="small" @click="handleCancel(order)">
                取消订单
              </el-button>
              <el-button v-if="order.status === '1'" type="primary" size="small" @click="goPay(order)">
                去支付
              </el-button>
              <el-button size="small" @click="goDetail(order)">订单详情</el-button>
            </div>
          </div>
        </div>
      </div>

      <div v-if="total > 0" class="pagination-container">
        <el-pagination background layout="total, sizes, prev, pager, next, jumper"
                       :total="total" :current-page.sync="pageNum" :page-size="pageSize"
                       :page-sizes="[10, 20, 50]"
                       @current-change="queryOrders" @size-change="changeSize"></el-pagination>
      </div>

      <!-- 微信扫码支付 -->
      <pay-qrcode-dialog ref="payDialog" @success="onPaySuccess" />
    </div>
  </portal-layout>
</template>
<script>
import PortalLayout from '@/components/PortalLayout.vue';
import PayQrcodeDialog from '@/components/PayQrcodeDialog.vue';
import api from '@/common/api';
import storage from '@/common/storage.js';

export default {
  name: 'PortalOrderList',
  components: { PortalLayout, PayQrcodeDialog },
  data() {
    return {
      loading: false,
      orders: [],
      total: 0,
      pageNum: 1,
      pageSize: 10,
      currentStatus: '',
      tabs: [
        { label: '全部', value: '' },
        { label: '待支付', value: '1' },
        { label: '已支付', value: '2' },
        { label: '已完成', value: '3' },
        { label: '已取消', value: '4' }
      ]
    }
  },
  created() {
    if (!this.checkLogin()) {
      return;
    }
    this.queryOrders();
  },
  methods: {
    checkLogin() {
      if (!storage.getString('portalMember')) {
        if (this.$route.name === 'PortalLogin') return false;
        this.$router.push({ name: 'PortalLogin', query: { redirect: this.$route.fullPath } }).catch(() => {});
        return false;
      }
      return true;
    },
    queryOrders() {
      this.loading = true;
      api.order_list({
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        status: this.currentStatus
      }).then((r) => {
        if (r.data.code === "200") {
          // 后端 R.ok(page) 走 data 字段，返回 MyBatis-Plus 分页对象
          const page = r.data.data || {};
          this.orders = page.records || [];
          this.total = page.total || 0;
        }
      }).catch(() => {
        // 401 已由 common/api.js 统一跳转登录页
      }).finally(() => {
        this.loading = false;
      });
    },
    changeStatus(status) {
      this.currentStatus = status;
      this.pageNum = 1;
      this.queryOrders();
    },
    changeSize(size) {
      this.pageSize = size;
      this.pageNum = 1;
      this.queryOrders();
    },
    statusText(status) {
      const map = { '1': '待支付', '2': '已支付', '3': '已完成', '4': '已取消' };
      return map[status] || '未知状态';
    },
    statusColor(status) {
      const map = { '1': '#faad14', '2': '#1890ff', '3': '#52c41a', '4': '#bfbfbf' };
      return map[status] || '#bfbfbf';
    },
    // 待支付订单继续支付：只传订单号，后端按订单重建金额与订单行
    goPay(order) {
      this.$refs.payDialog.open({
        orderNo: order.orderNo,
        amount: order.totalAmount
      });
    },
    onPaySuccess() {
      this.queryOrders();
    },
    handleCancel(order) {
      this.$confirm('确定要取消该订单吗？', '确认取消', {
        type: 'warning',
        confirmButtonText: '确定',
        cancelButtonText: '再想想'
      }).then(() => {
        api.order_cancel({ orderNo: order.orderNo }).then((r) => {
          if (r.data.code === "200") {
            this.$message.success('取消成功');
            this.queryOrders();
          } else {
            this.$message.error(r.data.msg || '取消失败');
          }
        }).catch(() => {});
      }).catch(() => {});
    },
    goDetail(order) {
      this.$router.push('/portal/order/detail?orderNo=' + order.orderNo).catch(() => {});
    },
    goShop() {
      this.$router.push('/portal/shop/list').catch(() => {});
    }
  }
};
</script>
<style scoped>
.page-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.page-title {
  font-size: 22px;
  color: #303133;
  margin: 0;
}
.filter-card {
  background-color: #fff;
  border-radius: 8px;
  padding: 15px 25px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  margin-bottom: 20px;
  display: flex;
  gap: 10px;
}
.filter-option {
  display: inline-block;
  padding: 5px 16px;
  font-size: 14px;
  color: #606266;
  border-radius: 15px;
  cursor: pointer;
  transition: all 0.3s;
}
.filter-option:hover {
  color: #409EFF;
}
.filter-option.active {
  background-color: #409EFF;
  color: #fff;
}
.order-list {
  min-height: 200px;
}
.order-card {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  margin-bottom: 20px;
  overflow: hidden;
}
.order-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 25px;
  background-color: #fafafa;
  border-bottom: 1px solid #ebeef5;
}
.order-no {
  font-size: 13px;
  color: #909399;
}
.order-status {
  font-size: 14px;
  font-weight: 500;
}
.order-body {
  padding: 5px 25px;
  cursor: pointer;
}
.order-item {
  display: flex;
  align-items: center;
  padding: 15px 0;
  border-bottom: 1px solid #f5f7fa;
}
.order-item:last-child {
  border-bottom: none;
}
.item-cover {
  flex-shrink: 0;
  width: 100px;
  height: 75px;
  border-radius: 6px;
  overflow: hidden;
  background-color: #f5f7fa;
}
.item-cover img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.item-info {
  flex: 1;
  min-width: 0;
  padding-left: 18px;
}
.item-title {
  font-size: 15px;
  color: #303133;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.item-subtitle {
  font-size: 13px;
  color: #909399;
  margin-top: 5px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.item-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 6px;
}
.meta-text {
  font-size: 12px;
  color: #909399;
}
.item-price {
  font-size: 13px;
  color: #606266;
  margin-top: 6px;
}
.order-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 25px;
  border-top: 1px solid #ebeef5;
}
.total-amount {
  font-size: 13px;
  color: #606266;
}
.total-amount em {
  font-size: 17px;
  font-style: normal;
  color: #F56C6C;
  font-weight: bold;
}
.btn-group {
  display: flex;
  align-items: center;
  gap: 10px;
}
.pay-time {
  font-size: 12px;
  color: #909399;
  margin-right: 5px;
}
.empty-tip {
  background-color: #fff;
  border-radius: 8px;
  text-align: center;
  color: #909399;
  padding: 60px 0;
  font-size: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}
.pagination-container {
  margin-top: 20px;
  text-align: right;
}
</style>
